import { useEffect } from 'react';
import { useParams } from 'react-router';
import OrganizationContainer from './state/OrganizationContainer';

// todo: better error management
export function useManagedOrgsFetching() {
    const { organizationId } = useParams<{ organizationId: string }>();
    const {
        orgManagedOrgs,
        orgManagedOrgsRef,
        getOrgManagedOrgsAll,
        loadingData,
        loadingDataRef,
        handleLoadingDataChange,
    } = OrganizationContainer.useContainer();

    useEffect(() => {
        async function initializeManagedOrgs() {
            if (!organizationId || loadingDataRef.current.managedOrgs == true) return;
            handleLoadingDataChange('managedOrgs', true);

            const org = orgManagedOrgsRef.current.find((mo) => mo.originatedByOrganizationId == organizationId);

            if (org) {
                handleLoadingDataChange('managedOrgs', false);
                return;
            }

            try {
                const result = await getOrgManagedOrgsAll(organizationId);
                if (result?.resultType !== 'Ok') {
                    console.error('Error loading managed organizations.');
                }
            } catch (error) {
                console.error('Error loading managed organizations.');
            } finally {
                handleLoadingDataChange('managedOrgs', false);
            }
        }

        initializeManagedOrgs();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [organizationId]);

    return { orgManagedOrgs, isLoading: loadingData.managedOrgs };
}
